import { extendObservable, autorun } from 'mobx'
import browserHistory from '../service/history.service'

class MenuStore {
  constructor (configStore) {
    extendObservable(this, {
      configStore,
      currentPage: browserHistory.location.pathname,
    })
    autorun(() => {

    })
  }

  setCurrentPage = href => {
    this.currentPage = href
  }
}

export default MenuStore
